import { ContextMenu } from '@welbe/web-design-system';
import { FiUserPlus } from 'react-icons/fi';
import { ContainerItem } from './AddCandidateButton.styles';

type AddCandidateButtonProps = {
	onUploadCandidates: () => void;
	onCreateCandidate: () => void;
};

export const AddCandidateButton = ({
	onUploadCandidates,
	onCreateCandidate,
}: AddCandidateButtonProps) => {
	const handleChange = (key: string) => {
		if (key === 'upload') {
			onUploadCandidates();
		} else if (key === 'new') {
			onCreateCandidate();
		}
	};
	return (
		<ContextMenu
			label="Añadir Candidatos"
			width="250px"
			onChange={(value) => handleChange(value.key)}
			options={[
				// <ContainerItem key="upload">
				// 	<span>Subir CSV</span>
				// 	<FiUpload />
				// </ContainerItem>,
				<ContainerItem key="new">
					<span>Nuevo Candidato</span>
					<FiUserPlus />
				</ContainerItem>,
			]}
		/>
	);
};
